export const setting= {
  name: "Miviajeseguro",
  production: true,
  c_domain: '.miviajeseguro.com',
  authApiUrl: 'https://fusionpax-api.fusionpax.com/api/',
  appUrl: 'https://login.miviajeseguro.com',
  appBookingBackoffice: 'https://booking-bo.miviajeseguro.com/',
  appBookingUrl: 'https://booking-app.miviajeseguro.com/',
  apiBookingUrl: 'https://booking-api.miviajeseguro.com/api/v1/',
  apiOctopusUrl: 'https://octopus-api.fusionpax.com/api',
  routeUploadFile: 'https://fusionpax-api.fusionpax.com/storage/',  // Temporal
  octopusUrl: 'https://octopus-api.fusionpax.com/api',
  apiStorageBooking: 'https://booking-api.miviajeseguro.com/storage/',
  apiAbacoUrl: 'https://abaco-api.miviajeseguro.com/api/v1/',
  clientIdPaypal:"EHd6g3jaGD82NlUcn09stPzBNEgVYQaSUge13EY8wMcbnXHXS_gAkGuEATvJ9qsCjRMCffvwzFVDDEH6", 
  client_id:  'QA7kxgtk2eKrJDwK',
  client_secret: 'mL6SNux7pD8p8FoQRneYz0BP9NI9AP1519938479',
  defauldTimeBooking: 10,
  ApiUser : "MVSO243578",
  ApiKey  : "7642M120N87VS23",
  abacoApiUser: "devUser",
  abacoApiKey: "DevUs2024#?13579",
  // Square payment platform
  squareLocationId: "EAAAlwG8UJT4eXk6_nuRU2-Sldiop1ADOrNsolhwXIKDV2TctNLqlLUgPxvKvhSL",
  squareApplicationId: "sandbox-sq0idb-ihglSG6-anE9432sChG_lA",
  booking_api_user: "PRODBOOKINGAPP1113",
  booking_api_key: "5846ade8904c81a33449ee2a5c15cc8151af2b7d5ba7bcae9129e9869fd324ab",
  app_names: {
  	booking_backoffice: 'backoffice',
  	zoco: 'zoco',
  	booking: 'booking',
  	abaco: 'abaco',
  	chat: 'chat',
  	octopus: 'octopus'
  },
  ActivatedGuard: true
};
